export default function (request, { urltemplate, server }) {
  const prefix = `${server.API_SERVER}/c`
  const prefix2 = `${server.API_SERVER}/cu`
  const fieldName = process.env.NODE_ENV === 'production' ? 'prod' : 'dev'

  return {
    setGlobalConfig ({ params, body }) {
      return request({
        url: urltemplate(`${prefix}/users/:userId/configs/global`, params),
        method: 'post',
        data: body
      })
    },

    getGlobalConfig ({ params }) {
      return request({
        url: urltemplate(`${prefix}/users/:userId/configs/global`, params),
        method: 'get'
      })
    },

    setSiteThemeConfig ({ params, body }) {
      return request({
        url: urltemplate(`${prefix}/users/:userId/configs/bucket/${fieldName}`, params),
        method: 'post',
        data: body
      })
    },

    getSiteThemeConfig ({ params }) {
      return request({
        url: urltemplate(`${prefix}/users/:userId/configs/bucket/${fieldName}`, params),
        method: 'get'
      })
    },

    setGlobalConfigStatus ({ params, body }) {
      return request({
        url: urltemplate(`${prefix2}/inner/customer_users/:userId/actions/initiate`, params),
        method: 'post',
        data: body
      })
    }

  }
}
